module.exports = __webpack_public_path__ + "img/features-content-img-2-ua.d0608664.png";